// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.DashboardSteps_journey__nK0\\+g {
  width: 100%;
  margin-bottom: 32px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  background: #F7F5F1;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 24px;
  padding: 28px 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}
@media (max-width: 768px) {
  .DashboardSteps_journey__nK0\\+g {
    padding: 20px;
    margin-bottom: 24px;
  }
}
.DashboardSteps_journey__head__PUCsD {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}
@media (max-width: 480px) {
  .DashboardSteps_journey__head__PUCsD {
    gap: 12px;
  }
}
.DashboardSteps_journey__mark__ipGWC {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #F7F5F1;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
  color: #67a27f;
  font-weight: 800;
  font-size: 16px;
  flex-shrink: 0;
}
.DashboardSteps_journey__text__ol9be h2 {
  margin: 0;
  font-weight: 800;
  color: #13231D;
  font-size: 48px;
  letter-spacing: -0.04em;
  line-height: 1;
}
@media (max-width: 1024px) {
  .DashboardSteps_journey__text__ol9be h2 {
    font-size: 36px;
  }
}
@media (max-width: 768px) {
  .DashboardSteps_journey__text__ol9be h2 {
    font-size: 28px;
  }
}
.DashboardSteps_journey__text__ol9be p {
  color: rgba(19, 35, 29, 0.6784313725);
  margin: 10px 0 0;
  max-width: 760px;
  font-size: 17px;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .DashboardSteps_journey__text__ol9be p {
    font-size: 14px;
    margin: 6px 0 0;
  }
}

.DashboardSteps_steps__KtTvn {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}
@media (max-width: 1024px) {
  .DashboardSteps_steps__KtTvn {
    grid-template-columns: 1fr;
  }
}
.DashboardSteps_steps--patient__f4Ku- {
  grid-template-columns: repeat(2, 1fr);
}
@media (max-width: 768px) {
  .DashboardSteps_steps--patient__f4Ku- {
    grid-template-columns: 1fr;
  }
}

.DashboardSteps_step__q8NN0 {
  border-radius: 18px;
  padding: 24px;
  min-height: 236px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  cursor: pointer;
}
.DashboardSteps_step--done__8pIIX {
  background: #F7F5F1;
  border: 1px solid rgba(130, 177, 148, 0.26);
}
.DashboardSteps_step--done__8pIIX .DashboardSteps_step__ico__V7L7F {
  background: #6da77c;
  color: #fff;
  box-shadow: 0 10px 20px rgba(109, 167, 124, 0.18);
}
.DashboardSteps_step--highlight__Z\\+8ax {
  background: linear-gradient(180deg, #FCFAF5, #F8F4E7);
  border: 1px solid rgba(214, 166, 64, 0.62);
  box-shadow: 0 12px 28px rgba(214, 166, 64, 0.12);
}
.DashboardSteps_step--highlight__Z\\+8ax .DashboardSteps_step__ico__V7L7F {
  background: #D6A640;
  color: #fff;
  box-shadow: 0 10px 20px rgba(214, 166, 64, 0.18);
}
.DashboardSteps_step--disabled__L0vE3 {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  opacity: 0.72;
}
.DashboardSteps_step--disabled__L0vE3 .DashboardSteps_step__ico__V7L7F {
  background: #eef2ef;
  color: rgba(19, 35, 29, 0.68);
  box-shadow: none;
}
.DashboardSteps_step__top__KQsWJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DashboardSteps_step__ico__V7L7F {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: #6da77c;
  color: #fff;
  font-weight: 900;
  font-size: 24px;
}
.DashboardSteps_step__title__RHXmc {
  margin: 36px 0 0;
  font-size: 20px;
  line-height: 1.25;
  letter-spacing: -0.02em;
  font-weight: 800;
  color: #13231D;
  margin-bottom: 10px;
}
.DashboardSteps_step__btn__VD9-o {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  width: 100%;
  border-radius: 16px;
  font-weight: 800;
  gap: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}
.DashboardSteps_step__btn--primary__cFkX8 {
  background: #82B194;
  color: #fff;
}
.DashboardSteps_step__btn--primary__cFkX8:hover {
  background: rgb(114.2980295567, 167.2019704433, 134.5591133005);
  transform: translateY(-1px);
}
.DashboardSteps_step__btn--primary-bd__X7Tsl {
  background: #82B194;
  color: #fff;
}
.DashboardSteps_step__btn--primary-bd__X7Tsl:hover {
  background: rgb(114.2980295567, 167.2019704433, 134.5591133005);
  transform: translateY(-1px);
}
.DashboardSteps_step__btn--disabled__kMsb2 {
  background: #f3f4f1;
  color: #9da5a2;
  border: 1px solid rgba(12, 36, 28, 0.08);
  cursor: pointer;
}
.DashboardSteps_step__btn--disabled__kMsb2:hover {
  background: #e9eae6;
}
.DashboardSteps_step__arrow__pQqsd {
  transition: transform 0.2s ease;
}
.DashboardSteps_step__q8NN0:hover .DashboardSteps_step__arrow__pQqsd {
  transform: translateX(4px);
}

.DashboardSteps_badge__YVzKw {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.DashboardSteps_badge--done__GeVy8 {
  color: #5c8a68;
}
.DashboardSteps_badge--progress__11YiL {
  color: #8a6516;
}
.DashboardSteps_badge--off__uZFRu {
  color: rgba(19, 35, 29, 0.68);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/dashboard/DashboardSteps/DashboardSteps.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AARA;EACI,WAAA;EACA,mBAAA;EACA,oFDLQ;ECMR,mBDOmB;ECNnB,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;AAWJ;AATI;EAVJ;IAWQ,aAAA;IACA,mBAAA;EAYN;AACF;AAVI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAYR;AAVQ;EANJ;IAOQ,SAAA;EAaV;AACF;AAVI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAYR;AARQ;EACI,SAAA;EACA,gBAAA;EACA,cD5BW;EC6BX,eAAA;EACA,uBAAA;EACA,cAAA;AAUZ;AARY;EARJ;IASQ,eAAA;EAWd;AACF;AATY;EAZJ;IAaQ,eAAA;EAYd;AACF;AATQ;EACI,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAWZ;AATY;EAPJ;IAQQ,eAAA;IACA,eAAA;EAYd;AACF;;AAPA;EACI,aAAA;EACA,gDAAA;EACA,SAAA;AAUJ;AARI;EALJ;IAMQ,0BAAA;EAWN;AACF;AATI;EACI,qCAAA;AAWR;AATQ;EAHJ;IAIQ,0BAAA;EAYV;AACF;;AARA;EACI,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AAWJ;AATI;EACI,mBD1Fe;EC2Ff,2CAAA;AAWR;AATQ;EACI,mBAAA;EACA,WAAA;EACA,iDAAA;AAWZ;AAPI;EACI,qDAAA;EACA,0CAAA;EACA,gDAAA;AASR;AAPQ;EACI,mBD/GW;ECgHX,WAAA;EACA,gDAAA;AASZ;AALI;EACI,mBDjHe;ECkHf,wCAAA;EACA,aAAA;AAOR;AALQ;EACI,mBAAA;EACA,6BDhHW;ECiHX,gBAAA;AAOZ;AAHI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAKR;AAFI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAIR;AADI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cD/Ie;ECgJf,mBAAA;AAGR;AAAI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AAER;AAAQ;EACI,mBD/KW;ECgLX,WAAA;AAEZ;AAAY;EACI,+DAAA;EACA,2BAAA;AAEhB;AAGQ;EACI,mBD1LW;EC2LX,WAAA;AADZ;AAGY;EACI,+DAAA;EACA,2BAAA;AADhB;AAKQ;EACI,mBAAA;EACA,cAAA;EACA,wCAAA;EACA,eAAA;AAHZ;AAKY;EACI,mBAAA;AAHhB;AAQI;EACI,+BAAA;AANR;AASI;EACI,0BAAA;AAPR;;AAWA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AARJ;AAUI;EACI,cAAA;AARR;AAWI;EACI,cAAA;AATR;AAYI;EACI,6BDxNe;AC8MvB","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import \"../../../assets/styles/variables\";\n\n$bw-primary: $color-primary;\n$bw-gold: $color-gold;\n$bw-muted: $text-secondary;\n$bw-border: $color-border;\n$bw-text: $text-main;\n\n.journey {\n    width: 100%;\n    margin-bottom: 32px;\n    font-family: $font-main;\n    background: $color-surface;\n    border: 1px solid rgba(12, 36, 28, 0.08);\n    border-radius: 24px;\n    padding: 28px 30px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, .03);\n\n    @media (max-width: 768px) {\n        padding: 20px;\n        margin-bottom: 24px;\n    }\n\n    &__head {\n        display: flex;\n        align-items: flex-start;\n        gap: 16px;\n        margin-bottom: 24px;\n\n        @media (max-width: 480px) {\n            gap: 12px;\n        }\n    }\n\n    &__mark {\n        width: 42px;\n        height: 42px;\n        border-radius: 50%;\n        display: grid;\n        place-items: center;\n        background: #F7F5F1;\n        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);\n        color: #67a27f;\n        font-weight: 800;\n        font-size: 16px;\n        flex-shrink: 0;\n    }\n\n    &__text {\n        h2 {\n            margin: 0;\n            font-weight: 800;\n            color: $bw-text;\n            font-size: 48px;\n            letter-spacing: -.04em;\n            line-height: 1;\n\n            @media (max-width: 1024px) {\n                font-size: 36px;\n            }\n\n            @media (max-width: 768px) {\n                font-size: 28px;\n            }\n        }\n\n        p {\n            color: #13231dad;\n            margin: 10px 0 0;\n            max-width: 760px;\n            font-size: 17px;\n            line-height: 1.6;\n\n            @media (max-width: 768px) {\n                font-size: 14px;\n                margin: 6px 0 0;\n            }\n        }\n    }\n}\n\n.steps {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 18px;\n\n    @media (max-width: 1024px) {\n        grid-template-columns: 1fr;\n    }\n\n    &--patient {\n        grid-template-columns: repeat(2, 1fr);\n\n        @media (max-width: 768px) {\n            grid-template-columns: 1fr;\n        }\n    }\n}\n\n.step {\n    border-radius: 18px;\n    padding: 24px;\n    min-height: 236px;\n    display: flex;\n    flex-direction: column;\n    transition: all 0.3s ease;\n    cursor: pointer;\n\n    &--done {\n        background: $color-surface;\n        border: 1px solid rgba(130, 177, 148, 0.26);\n\n        .step__ico {\n            background: #6da77c;\n            color: #fff;\n            box-shadow: 0 10px 20px rgba(109, 167, 124, 0.18);\n        }\n    }\n\n    &--highlight {\n        background: linear-gradient(180deg, #FCFAF5, #F8F4E7);\n        border: 1px solid rgba(214, 166, 64, 0.62);\n        box-shadow: 0 12px 28px rgba(214, 166, 64, 0.12);\n\n        .step__ico {\n            background: $bw-gold;\n            color: #fff;\n            box-shadow: 0 10px 20px rgba(214, 166, 64, 0.18);\n        }\n    }\n\n    &--disabled {\n        background: $color-surface ;\n        border: 1px solid rgba(16, 25, 21, 0.08);\n        opacity: 0.72;\n\n        .step__ico {\n            background: #eef2ef;\n            color: $bw-muted;\n            box-shadow: none;\n        }\n    }\n\n    &__top {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    &__ico {\n        width: 52px;\n        height: 52px;\n        border-radius: 14px;\n        display: grid;\n        place-items: center;\n        background: #6da77c;\n        color: #fff;\n        font-weight: 900;\n        font-size: 24px;\n    }\n\n    &__title {\n        margin: 36px 0 0;\n        font-size: 20px;\n        line-height: 1.25;\n        letter-spacing: -0.02em;\n        font-weight: 800;\n        color: $bw-text;\n        margin-bottom: 10px;\n    }\n\n    &__btn {\n        margin-top: auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        min-height: 52px;\n        width: 100%;\n        border-radius: 16px;\n        font-weight: 800;\n        gap: 8px;\n        border: none;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &--primary {\n            background: $bw-primary;\n            color: #fff;\n\n            &:hover {\n                background: darken($bw-primary, 5%);\n                transform: translateY(-1px);\n            }\n\n        }\n\n        &--primary-bd {\n            background: $bw-primary;\n            color: #fff;\n\n            &:hover {\n                background: darken($bw-primary, 5%);\n                transform: translateY(-1px);\n            }\n        }\n\n        &--disabled {\n            background: #f3f4f1;\n            color: #9da5a2;\n            border: 1px solid rgba(12, 36, 28, 0.08);\n            cursor: pointer;\n\n            &:hover {\n                background: #e9eae6;\n            }\n        }\n    }\n\n    &__arrow {\n        transition: transform 0.2s ease;\n    }\n\n    &:hover .step__arrow {\n        transform: translateX(4px);\n    }\n}\n\n.badge {\n    font-size: 12px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n\n    &--done {\n        color: #5c8a68;\n    }\n\n    &--progress {\n        color: #8a6516;\n    }\n\n    &--off {\n        color: $bw-muted;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"journey": `DashboardSteps_journey__nK0+g`,
	"journey__head": `DashboardSteps_journey__head__PUCsD`,
	"journey__mark": `DashboardSteps_journey__mark__ipGWC`,
	"journey__text": `DashboardSteps_journey__text__ol9be`,
	"steps": `DashboardSteps_steps__KtTvn`,
	"steps--patient": `DashboardSteps_steps--patient__f4Ku-`,
	"step": `DashboardSteps_step__q8NN0`,
	"step--done": `DashboardSteps_step--done__8pIIX`,
	"step__ico": `DashboardSteps_step__ico__V7L7F`,
	"step--highlight": `DashboardSteps_step--highlight__Z+8ax`,
	"step--disabled": `DashboardSteps_step--disabled__L0vE3`,
	"step__top": `DashboardSteps_step__top__KQsWJ`,
	"step__title": `DashboardSteps_step__title__RHXmc`,
	"step__btn": `DashboardSteps_step__btn__VD9-o`,
	"step__btn--primary": `DashboardSteps_step__btn--primary__cFkX8`,
	"step__btn--primary-bd": `DashboardSteps_step__btn--primary-bd__X7Tsl`,
	"step__btn--disabled": `DashboardSteps_step__btn--disabled__kMsb2`,
	"step__arrow": `DashboardSteps_step__arrow__pQqsd`,
	"badge": `DashboardSteps_badge__YVzKw`,
	"badge--done": `DashboardSteps_badge--done__GeVy8`,
	"badge--progress": `DashboardSteps_badge--progress__11YiL`,
	"badge--off": `DashboardSteps_badge--off__uZFRu`
};
export default ___CSS_LOADER_EXPORT___;
